// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Dce7","title":"styles_title__dpznC"};